import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { OrganisationDto, TenantDto } from '@careapp-group/ng-sdk';

export interface OrganisationsTableData extends OrganisationDto {
  /**
   * Where to route to if the user clicks on the organisations
   */
  link?: {
    routerLink: string | any[];
    queryParams?: {
      [k: string]: any;
    };
  };
}
@Component({
    selector: 'organisations-table',
    templateUrl: './organisations-table.component.html',
    styleUrls: ['./organisations-table.component.scss'],
    standalone: false
})
export class OrganisationsTableComponent implements OnInit {
  /**
   * The list of organisations to show in the table
   */
  @Input() organisations: Array<OrganisationsTableData>;

  /**
   * The list of existing tenants that an organisation may be part of.
   */
  @Input() tenants: { [id: string]: TenantDto };

  /**
   * Whether to allow selection of organisation. If true,
   * a selection checkbox is added at the start of each row,
   * as well as a select all checkbox.
   */
  @Input()
  set allowSelection(value: boolean) {
    if (value) {
      this._displayedColumns = ['selection', ...this._columns];
    } else {
      this._displayedColumns = this._columns;
    }
    this._allowSelection = value;
  }

  /**
   * The columns to display in the table. Possible options:
   *
   *  - name
   *  - number
   *  - address
   */
  @Input()
  set columns(value: Array<string>) {
    if (value) {
      this._displayedColumns = ['selection', ...value];
    } else {
      this._displayedColumns = value;
    }
    this._columns = value;
  }

  /**
   * Emits the list of selected organisations
   */
  @Output() currentSelection = new EventEmitter<OrganisationDto[]>();

  _displayedColumns: Array<string> = ['name', 'number', 'address', 'tenant'];
  _allowSelection = false;
  _columns: Array<string> = ['name', 'number', 'address', 'tenant'];
  _selection = new SelectionModel<OrganisationDto>(true, []);

  ngOnInit() {
    this._selection.changed.subscribe(() => {
      this.currentSelection.next(this._selection.selected);
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this._selection.selected.length;
    const numRows = this.organisations.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this._selection.clear()
      : this.organisations.forEach((row) => this._selection.select(row));
  }
}
